import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "pa-4" }
const _hoisted_3 = { class: "ma-2" }
const _hoisted_4 = { class: "font-weight-bold" }
const _hoisted_5 = { class: "ma-2" }
const _hoisted_6 = { class: "font-weight-bold" }
const _hoisted_7 = { class: "ma-2" }
const _hoisted_8 = { class: "font-weight-bold" }
const _hoisted_9 = { class: "ma-2" }
const _hoisted_10 = { class: "font-weight-bold" }
const _hoisted_11 = {
  key: 0,
  class: "pa-4"
}
const _hoisted_12 = { class: "ma-2" }
const _hoisted_13 = { class: "ma-2" }
const _hoisted_14 = {
  key: 0,
  class: "ma-2"
}
const _hoisted_15 = {
  key: 1,
  class: "ma-2"
}
const _hoisted_16 = {
  key: 1,
  class: "pa-4"
}
const _hoisted_17 = {
  key: 0,
  class: "ma-2"
}
const _hoisted_18 = { class: "pa-4 text-caption text-grey" }
const _hoisted_19 = { class: "info-line" }
const _hoisted_20 = { class: "info-line" }
const _hoisted_21 = { class: "info-line" }
const _hoisted_22 = { class: "info-line" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "info-line" }
const _hoisted_26 = { class: "info-line" }
const _hoisted_27 = { key: 2 }
const _hoisted_28 = { class: "info-line" }

import {ref, watch} from 'vue'
import {ApiMap} from '@/api/type'
import {useApi} from "@/api/handler";
import {proposal} from "@/api";


export default /*@__PURE__*/_defineComponent({
  __name: 'PropSidebar',
  props: {
    data: {}
  },
  setup(__props: any) {

const props = __props
const GameStatus = ref<ApiMap['/game/status/:id']['resp'] | null>(null)
const propStage = ['初始化提案积分', '选择提案提出轮次', '每轮提出提案', '投票', '正式游戏']
const proposalTeam = ref<ApiMap['/proposal/list']['resp']>([])
const showOverlay = ref<boolean>(false)
const winnerInfo = ref<ApiMap['/proposal/selected/:game/:round']['resp'] | null>(null)

const useProposalList = () => {
  if (!GameStatus.value) return
  if (GameStatus.value.proposalRound === 0) return
  useApi({
    api: proposal.ProposalList(GameStatus.value.id, GameStatus.value.proposalRound),
    onSuccess: resp => {
      proposalTeam.value = resp.data as ApiMap['/proposal/list']['resp']
    }
  })
}

const useWinProposal = () => {
  if (!GameStatus.value) return
  useApi({
    api: proposal.WinProposal(GameStatus.value.id, GameStatus.value.proposalRound),
    onSuccess: resp => {
      winnerInfo.value = resp.data as ApiMap['/proposal/selected/:game/:round']['resp']
    }
  })
}

watch(() => props.data, newVal => {
  GameStatus.value = newVal ?? null
  if (!GameStatus.value) return
  if (GameStatus.value?.status === 2) return
  useProposalList()
  if (GameStatus.value.proposalStage === 4) useWinProposal()
}, {immediate: true})

return (_ctx: any,_cache: any) => {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_overlay = _resolveComponent("v-overlay")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_card, {
      class: "prop-sidebar white",
      style: {"min-width":"300px"}
    }, {
      default: _withCtx(() => [
        (GameStatus.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _cache[12] || (_cache[12] = _createElementVNode("div", { class: "text-h6 pa-4 d-flex align-center justify-center bg-indigo-lighten-2" }, " 提案赛阶段 ", -1)),
              _createVNode(_component_v_divider),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _cache[2] || (_cache[2] = _createTextVNode("游戏 ID： ")),
                  _createElementVNode("span", _hoisted_4, _toDisplayString(GameStatus.value.id), 1)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _cache[3] || (_cache[3] = _createTextVNode("当前总学生数： ")),
                  _createElementVNode("span", _hoisted_6, _toDisplayString(GameStatus.value.studentCount), 1)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _cache[4] || (_cache[4] = _createTextVNode("当前组数： ")),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(GameStatus.value.teamCount), 1)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _cache[5] || (_cache[5] = _createTextVNode("每组基准人数： ")),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(GameStatus.value.teamMemberCount), 1)
                ])
              ]),
              _createVNode(_component_v_divider, { class: "my-2" }),
              (GameStatus.value && GameStatus.value.status !== 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _cache[6] || (_cache[6] = _createTextVNode("提案阶段： ")),
                      _createVNode(_component_v_chip, {
                        color: "orange",
                        "text-color": "white",
                        class: "mb-1"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(propStage[GameStatus.value.proposalStage]), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _cache[7] || (_cache[7] = _createTextVNode("提案赛轮次： ")),
                      _createVNode(_component_v_chip, {
                        color: "red-lighten-1",
                        "text-color": "white",
                        class: "mb-1"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 第 " + _toDisplayString(GameStatus.value.proposalRound) + " 轮 ", 1)
                        ]),
                        _: 1
                      })
                    ]),
                    (proposalTeam.value && GameStatus.value.proposalStage >= 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _cache[8] || (_cache[8] = _createTextVNode("本轮提案小组： ")),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(proposalTeam.value, (v, i) => {
                            return (_openBlock(), _createBlock(_component_v_chip, {
                              density: "compact",
                              key: i,
                              class: "ma-1"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" 第 " + _toDisplayString(v.proposerTeamId) + " 组 ", 1)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (proposalTeam.value?.filter((item) => item.isSelected).length !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _cache[9] || (_cache[9] = _createTextVNode("提案中选小组： ")),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(proposalTeam.value.filter((item) => item.isSelected), (v, i) => {
                            return (_openBlock(), _createBlock(_component_v_chip, {
                              color: "indigo",
                              key: i,
                              class: "ma-1",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (showOverlay.value = true))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" 第 " + _toDisplayString(v.proposerTeamId) + " 组 ", 1)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (GameStatus.value && GameStatus.value.status === 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    (proposalTeam.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _cache[11] || (_cache[11] = _createTextVNode("游戏阶段： ")),
                          _createVNode(_component_v_chip, {
                            class: "mb-1",
                            color: "red"
                          }, {
                            default: _withCtx(() => _cache[10] || (_cache[10] = [
                              _createTextVNode("已结束")
                            ])),
                            _: 1,
                            __: [10]
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_v_divider, { class: "my-2" }),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", null, "上次保存时间：" + _toDisplayString(GameStatus.value.lastSavedAt), 1),
                _createElementVNode("div", null, "创建时间：" + _toDisplayString(GameStatus.value.gmtCreate), 1),
                _createElementVNode("div", null, "更新时间：" + _toDisplayString(GameStatus.value.gmtUpdate), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_v_overlay, {
      modelValue: showOverlay.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showOverlay).value = $event)),
      class: "align-center justify-center"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          class: "pa-6",
          elevation: "8",
          width: "400",
          rounded: "xl"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "text-h6 font-weight-bold mb-3" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  start: "",
                  class: "mr-2",
                  color: "primary"
                }, {
                  default: _withCtx(() => _cache[13] || (_cache[13] = [
                    _createTextVNode("mdi-account-group")
                  ])),
                  _: 1,
                  __: [13]
                }),
                _cache[14] || (_cache[14] = _createTextVNode(" 提案中选小组评分信息 "))
              ]),
              _: 1,
              __: [14]
            }),
            _createVNode(_component_v_divider, { class: "mb-2" }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_19, [
                  _cache[15] || (_cache[15] = _createElementVNode("span", { class: "label" }, "中选小组：", -1)),
                  _createTextVNode("第 " + _toDisplayString(winnerInfo.value.teamId) + " 组", 1)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _cache[16] || (_cache[16] = _createElementVNode("span", { class: "label" }, "组长：", -1)),
                  _createTextVNode(_toDisplayString(winnerInfo.value.leaderName), 1)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _cache[17] || (_cache[17] = _createElementVNode("span", { class: "label" }, "票数：", -1)),
                  _createTextVNode(_toDisplayString(winnerInfo.value.score) + " 票", 1)
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _cache[18] || (_cache[18] = _createElementVNode("span", { class: "label" }, "当前轮次：", -1)),
                  _createTextVNode("第 " + _toDisplayString(winnerInfo.value.round) + " 轮", 1)
                ]),
                (winnerInfo.value && GameStatus.value?.proposalRound === 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _cache[20] || (_cache[20] = _createElementVNode("div", { class: "mt-4 font-weight-medium mb-2" }, "评分分配：", -1)),
                      _createVNode(_component_v_list, {
                        density: "compact",
                        class: "bg-grey-lighten-5 rounded"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(winnerInfo.value.allocations, (score, index) => {
                            return (_openBlock(), _createBlock(_component_v_list_item, {
                              class: "ma-0",
                              key: index
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" 第 " + _toDisplayString(winnerInfo.value.team[index]) + " 组：", 1),
                                _createElementVNode("strong", null, _toDisplayString(score), 1),
                                _cache[19] || (_cache[19] = _createTextVNode(" 分 "))
                              ]),
                              _: 2,
                              __: [19]
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (winnerInfo.value && GameStatus.value?.proposalRound === 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _cache[21] || (_cache[21] = _createElementVNode("span", { class: "label" }, "辩论正方：", -1)),
                        _createElementVNode("span", null, _toDisplayString(winnerInfo.value.team.slice(0, Math.floor(winnerInfo.value.team.length / 2)).map((item) => `第 ${item} 组`).join('，')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _cache[22] || (_cache[22] = _createElementVNode("span", { class: "label" }, "辩论反方：", -1)),
                        _createElementVNode("span", null, _toDisplayString(winnerInfo.value.team.slice(Math.floor(winnerInfo.value.team.length / 2)).map((item) => `第 ${item} 组`).join('，')), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (winnerInfo.value && GameStatus.value?.proposalRound === 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _cache[23] || (_cache[23] = _createElementVNode("span", { class: "label" }, "参与游戏小组：", -1)),
                        _createElementVNode("span", null, _toDisplayString(winnerInfo.value.team.map((item) => `第 ${item} 组`).join('，')), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})